<template>
    <div class="sm:max-w-4xl mx-auto">
        <resource-index title="Комиссии" endpoint="partner/transactions">
            <template v-slot:table-header>
                <tr class="border-b">
                    <th class="text-left p-3 px-5" scope="col">Заказ</th>
                    <th class="text-left p-3 px-5" scope="col">Клиент</th>
                    <th class="text-left p-3 px-5" scope="col">Сумма</th>
                    <th class="text-left p-3 px-5" scope="col">Комиссия, ₽</th>
                </tr>
            </template>

            <template v-slot:row="slotProps">
                <td class="p-3 px-5">
                    <span
                        class="badge whitespace-no-wrap badge-indigo"
                        v-if="slotProps.entry.order"
                    >(#{{ slotProps.entry.order.id }}) {{ slotProps.entry.order.product.name }}</span>
                    <span
                        class="badge whitespace-no-wrap badge-danger"
                        v-else-if="slotProps.entry.amount < 0"
                    >Снятие</span>
                    <span class="badge whitespace-no-wrap badge-warning" v-else>–</span>
                </td>

                <td class="p-3 px-5">
                    <span
                        v-if="slotProps.entry.order"
                    >{{ slotProps.entry.order.customer.full_name }}</span>
                    <span v-else>–</span>
                </td>

                <td class="p-3 px-5">
                    <span
                        v-if="slotProps.entry.order"
                        class="badge whitespace-no-wrap badge-warning"
                    >{{ slotProps.entry.order.amount }} ₽</span>
                    <span v-else>–</span>
                </td>

                <td class="p-3 px-5">
                    <span
                        class="badge whitespace-no-wrap badge-success"
                    >{{ slotProps.entry.amount }} ₽</span>
                </td>
            </template>
        </resource-index>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    }
};
</script>